<button class="secondary-bg-color secondary-text-color no-padding no-border" [title]="'component.header.hamburger_button.button_title' | translate">
  <fa-icon [fixedWidth]="true" [icon]="faFtsHamburger"></fa-icon>
</button>
